import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Button } from "antd";

import { DateRangePicker } from "../../components/generic";

import { IconLight } from "../../components";

class Toolbar extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedValues: {
        startDateTime: props.startDateTime,
        endDateTime: "",
        timePeriod: props.selectedTimePeriod
      },
      options: {
        timePeriod: props.timePeriodOptions
      }
    };

    this.onUpdateTimePeriod = this.onUpdateTimePeriod.bind(this);
    this.onClickButtonUpdate = this.onClickButtonUpdate.bind(this);
    this.onUpdateDateRange = this.onUpdateDateRange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(prevState => ({
      selectedValues: {
        ...prevState.selectedValues,
        // endDateTime: "",
        startDateTime: nextProps.startDateTime,
        timePeriod: nextProps.selectedTimePeriod
      },
      options: {
        ...prevState.options,
        timePeriod: nextProps.timePeriodOptions
      }
    }));
  }

  onUpdateDateRange(startDateTime, endDateTime, timePeriod, doUpdate, doRun) {
    this.setState(
      prevState => ({
        selectedValues: {
          ...prevState.selectedValues,
          startDateTime: startDateTime,
          endDateTime: endDateTime,
          timePeriod: timePeriod
        }
      }),
      () => {
        if (doUpdate) this.onUpdateTimePeriod(doRun); //update parent so that startdt gets updated. otherwise it gets reset.FCAS-371
      }
    );
  }

  onUpdateTimePeriod(doRun) {
    const {
      selectedValues: { startDateTime, endDateTime, timePeriod }
    } = this.state;
    this.props.onUpdateTimePeriod(
      startDateTime,
      endDateTime,
      timePeriod,
      doRun
    );
  }

  onClickButtonUpdate(event) {
    if (event) event.preventDefault();

    this.onUpdateTimePeriod(true);
  }

  render() {
    const { className, isLoading, reportCount } = this.props;
    const {
      selectedValues: { startDateTime, timePeriod },
      options
    } = this.state;
    return (
      <div className={`cp-core-toolbar ${className}`}>
        <Form layout="inline">
          <Form.Item>
            <DateRangePicker
              showTimePicker={true}
              startDateTime={startDateTime}
              startDtFormat="YYYY-MM-DDTHH:mm:00" //Note changing seconds to zero
              timePeriodOptions={options.timePeriod}
              timePeriod={timePeriod}
              onUpdate={this.onUpdateDateRange}
            />
          </Form.Item>
          <Form.Item>
            <Button
              // style={{ marginTop: "7px" }}
              loading={isLoading}
              type="primary"
              onClick={this.onClickButtonUpdate}
              style={{
                visibility:
                  reportCount && reportCount > 0 ? "visible" : "hidden"
              }}
            >
              {!isLoading && <IconLight icon={"play"} />} Run all{" "}
              {reportCount && <span>({reportCount})</span>}
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

Toolbar.propTypes = {
  className: PropTypes.string,
  timePeriodOptions: PropTypes.array.isRequired,
  selectedTimePeriod: PropTypes.string.isRequired,
  startDateTime: PropTypes.string.isRequired,
  onUpdateTimePeriod: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  reportCount: PropTypes.number
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/views/core/core_toolbar/CoreToolbar.jsx